import {Component, input, signal} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {TranslocoPipe} from '@jsverse/transloco';
import {CommentModalXComponent} from '../comment-modal-x/comment-modal-x.component';
import {CommentContainer} from '../comment-modal-x/comment-container';

@Component({
  selector: 'app-comment-modal-button',
  imports: [Button, Tooltip, TranslocoPipe, CommentModalXComponent],
  templateUrl: './comment-modal-button.component.html',
})
export class CommentModalButtonComponent {
  control = input.required<AbstractControl | null>();
  isReadOnly = input<boolean>(false);

  protected modalVisible = signal(false);
  protected activeCommentContainer = signal<CommentContainer>({comment: ''});

  protected openModal(): void {
    this.activeCommentContainer.set({comment: this.control()?.value ?? ''});
    this.modalVisible.set(true);
  }

  protected onSave(value: string): void {
    const ctrl = this.control();
    if (ctrl && !this.isReadOnly()) {
      ctrl.setValue(value);
      ctrl.markAsDirty();
      ctrl.markAsTouched();
    }
  }
}
